import Config from './Config.js';

class PopupManager {
    init(game)
    {
        this._game = game;
        this._block = new Phaser.Graphics(this._game, 0, 0);



        this._block.beginFill(0x190000, 0.5);

        this._block.drawRect(0, 0, 10, 10);
        this._block.endFill();
        this._block.inputEnabled = true;

        game.onResume.add(() =>
        {
            this.popups.forEach((popup) =>
            {
                popup.visible = true;
            });
        });
    }

    show(popupClass, params = null)
    {
        this._block.width = Config.GAME_WIDTH;
        this._block.height = Config.GAME_HEIGHT;
        this._block.inputEnabled = true;
        this._game.world.addChild(this._block);

        const popup = new popupClass(this._game, params);
        if ('alignToWorld' in popup && typeof popup.alignToWorld === 'function')
        {
            popup.alignToWorld(Config.GAME_WIDTH, Config.GAME_HEIGHT);
        }
        else
        {
            popup.x = (Config.GAME_WIDTH - popup.width >> 1);
            popup.y = (Config.GAME_HEIGHT - popup.height >> 1);
        }

        this.popups.push(popup);
        this._game.world.addChild(popup);
        return popup;
    }

    redraw()
    {
        this._block.width = Config.GAME_WIDTH;
        this._block.height = Config.GAME_HEIGHT;
        this._block.inputEnabled = true;

        this.popups.forEach((popup) =>
        {
            this._game.world.addChild(this._block);
            this._game.world.setChildIndex(popup, this._game.world.children.length - 1);

            if (('redraw' in popup) && typeof popup.redraw === 'function' && popup.parent)
            {
                popup.redraw();
            }

            if ('alignToWorld' in popup && typeof popup.alignToWorld === 'function')
            {
                popup.alignToWorld(Config.GAME_WIDTH, Config.GAME_HEIGHT);
            }
            else
            {
                popup.position.set(
                    Config.GAME_WIDTH - popup.width >> 1,
                    Config.GAME_HEIGHT - popup.height >> 1
                );
            }
        });
    }

    hide(popup)
    {
        popup.parent.remove(popup, true);

        const popups = this.popups;
        let popupIndex = popups.indexOf(popup);
        if (popupIndex !== -1)
        {
            popups.splice(popupIndex, 1);
        }

        if (!popups.length)
        {
            this._game.world.removeChild(this._block);
        }
        else
        {
            const backPopup = popups[0];
            const backPopupIndex = backPopup.parent.getChildIndex(backPopup);
            this._game.world.setChildIndex(this._block, Math.max(0, backPopupIndex - 1));
        }
    }

    hideByName(name)
    {
        let popup = this.popups.filter((popup) => popup.name === name);
        if (popup && popup.length)
        {
            this.hide(popup[0]);
        }
    }

    get popups()
    {
        return (this._popups = this._popups || []);
    }
}

export default new PopupManager();